import { PageContent } from "@/functions/articlePageFunctions";
import { ProductCategoryPageProductProps } from "@/pages/nettbutikk/[categorySlug]";

import { BaseLayout } from "../BaseLayout";
import { ArticleList } from "./ArticleList";
import { ArticlePage } from "./ArticlePage";
import { HeroImage } from "./components/HeroImage";

type ArticleLayoutProps = {
  content: PageContent;
  products: ProductCategoryPageProductProps[];
};

export const ArticleLayout = ({ content, products }: ArticleLayoutProps) => {
  const seo = {
    title: content.seo_title ?? content.title,
    description: content.seo_description ?? content.description,
    image: content.seoSrc,
    translations: content.translations || [],
  };

  const isFullLayout = content.image_layout === "full";

  return (
    <BaseLayout
      seo={seo}
      header={{
        title: content.title,
        overlay: true,
        inverse: isFullLayout ? false : true,
      }}
      footer
    >
      {isFullLayout && (
        <HeroImage heroSrc={content.heroSrc} image={content.image} />
      )}
      {content.page_type === "list" ? (
        <ArticleList content={content} />
      ) : (
        <ArticlePage content={content} products={products} />
      )}
    </BaseLayout>
  );
};
